var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2263 15.4491L17.1571 15.0986C16.42 15.0141 15.695 15.2678 15.1755 15.7874L12.9521 18.0107C9.53254 16.2707 6.72921 13.4795 4.98921 10.0478L7.22462 7.81239C7.74421 7.29281 7.99796 6.56781 7.91337 5.83072L7.56296 2.78572C7.41796 1.56531 6.39087 0.646973 5.15837 0.646973H3.06796C1.70254 0.646973 0.566706 1.78281 0.651289 3.14822C1.29171 13.4674 9.54462 21.7082 19.8517 22.3486C21.2171 22.4332 22.353 21.2974 22.353 19.932V17.8416C22.365 16.6211 21.4467 15.5941 20.2263 15.4491Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.84a7e5500d39efe4ffc34aab82c3e321.svg";
export { ForwardRef as ReactComponent };